/** Version label for the current pilot DUA (see docs/legal/pilot-data-use-agreement-template.md). */
export const CURRENT_DATA_SHARING_AGREEMENT_VERSION = 'DUA-2026-09';

export const DATA_SHARING_AGREEMENT_DOC_PATH =
  'docs/legal/pilot-data-use-agreement-template.md';
